import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import IconContainer from './icon_container';

export default function VoiceIcon({ className }) {
  return (
    <IconContainer className={classnames('voiceIconContainer', className)} viewBox="0 0 16 16">
      <g className="voiceIcon" fillRule="evenodd">
        <path
          d="M13.5,4.8 C13.2235,4.8 13,5.0235 13,5.3 C13,5.5765 13.2235,5.8 13.5,5.8 L15,5.8 C15.2765,5.8 15.5,5.5765 15.5,5.3 C15.5,5.0235 15.2765,4.8 15,4.8 L13.5,4.8 Z M9.5,2.5 C9.7765,2.5 10,2.2765 10,2 L10,0.5 C10,0.2235 9.7765,0 9.5,0 C9.2235,0 9,0.2235 9,0.5 L9,2 C9,2.2765 9.2235,2.5 9.5,2.5 L9.5,2.5 Z M13.045125,2.69575 L14.096125,1.64575 C14.289125,1.45175 14.289125,1.13825 14.096125,0.94475 C13.902625,0.75175 13.589125,0.75175 13.395125,0.94475 L12.345125,1.99575 C12.151625,2.18925 12.151625,2.50275 12.345125,2.69575 C12.538125,2.88975 12.851625,2.88975 13.045125,2.69575 L13.045125,2.69575 Z"
          fill="currentColor"
        />
        <path
          d="M10.9033775,14.7854507 C11.0794004,14.7541578 11.2369827,14.6619553 11.3520961,14.5284015 L12.6161076,13.068809 C12.8820977,12.7609088 12.8569516,12.304367 12.5574334,12.0266421 L10.6709156,10.2753546 C10.3719562,9.9981885 9.90423842,9.99483568 9.60192619,10.2675314 L8.59328742,11.1778209 C8.36864876,11.3806662 8.04398443,11.4354289 7.76123029,11.3214332 C7.30580614,11.1387047 6.41060431,10.5145221 5.51707888,9.67855339 L5.15273956,9.28292112 C4.31677081,8.38939569 3.69258826,7.49419386 3.50930099,7.03876971 C3.39586406,6.75601557 3.45062672,6.43135124 3.65291327,6.20671258 L4.56320277,5.19863261 C4.83645727,4.89576158 4.83310445,4.42804377 4.55593834,4.12964316 L2.80409206,2.24256664 C2.52636715,1.94304842 2.06982539,1.9179023 1.76248394,2.18389236 L0.302332634,3.44790393 C0.169337605,3.56301728 0.0771351691,3.72059962 0.0458422212,3.89662246 C-0.0932996365,4.68453418 -0.112298926,7.02144683 3.01029023,10.6760161 L4.13404235,11.7997682 C7.78861162,14.9217986 10.1154658,14.9245926 10.9033775,14.7854507 Z"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.8"
        />
      </g>
    </IconContainer>
  );
}

VoiceIcon.propTypes = {
  className: PropTypes.string,
};
